import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setMachineID } from "../../Landing/Actions";
import * as Actions from '../Actions/index';

const mapStatetoProps = state => {

    const { landing ,cookBook} = state;
    return {
        machineID:landing.machineID,
        kitchenId:landing.kitchenId,
        dishes:cookBook.dishes,
        dishId:cookBook.dishId,
        ingredientId:cookBook.ingredientId,
        recipeId:cookBook.recipeId,
        ingredients:cookBook.ingredients,
        recipes:cookBook.recipes,
        selectedDish:cookBook.selectedDish,
        selectedIngredient:cookBook.selectedIngredient,
        selectedRecipe:cookBook.selectedRecipe,
        editMode:cookBook.editMode,
        objectToEdit:cookBook.objectToEdit,
        payload:cookBook.payload,
        DispenserTypes: cookBook.DispenserTypes,
        HeatingProfiles: cookBook.HeatingProfiles,
        Allergens: cookBook.Allergens,
        Patterns: cookBook.Patterns,
        containerTypes: cookBook.containerTypes,
        baseTypes: cookBook.baseTypes,
        spoutTypes: cookBook.spoutTypes
    }
};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({
        setMachineID:setMachineID,
        clearSelectData:Actions.clearSelectData,
        getDishes:Actions.getDishes,
        getMoreDishes:Actions.getMoreDishes,
        getIngredients:Actions.getIngredients,
        getMoreIngredients:Actions.getMoreIngredients,
        getRecipes:Actions.getRecipes,
        getMoreRecipes:Actions.getMoreRecipes,
        selectDish:Actions.selectDish,
        updateDish:Actions.updateDish,
        addTagOnDish:Actions.addTagOnDish,
        removeTagOfDish:Actions.removeTagOfDish,
        addImagePathOnDish:Actions.addImagePathOnDish,
        removeImagePathOfDish:Actions.removeImagePathOfDish,
        selectRecipe:Actions.selectRecipe,
        selectIngredient:Actions.selectIngredient,
        getIngredient:Actions.getIngredientData,
        getDish:Actions.getDishData,
        getRecipe:Actions.getRecipeData,
        changeEditMode:Actions.changeEditMode,
        updateIngredient:Actions.updateIngredient,
        updateRecipe:Actions.updateRecipe,
        updatePayload:Actions.updatePayload,
        setInitialPayload:Actions.setInitialPayload,
        setInitialObjectToEdit:Actions.setInitialObjectToEdit,

    },
    dispatch
    )
});

export default connect(mapStatetoProps,mapDispatchToProps);